import React from 'react';
import { Dropdown } from '@getsynapse/design-system';
import { ActionsProps } from '../types';

const maxVisible = 2;

const Actions: React.FC<ActionsProps> = ({ actions }) => {
  const visibleActions =
    actions.length > maxVisible ? actions.slice(0, 1) : actions;
  const hiddenActions = actions.length > maxVisible ? actions.slice(1) : [];

  const handleActionClick = (action: typeof actions[0]) => {
    if (!action.disabled) {
      action.onClick();
    }
  };

  const dropdownOptions = hiddenActions.map((action) => ({
    value: action.id,
    label: action.label,
    disabled: action.disabled,
    icon: action.icon,
    onClick: () => handleActionClick(action),
  }));

  const handleDropdownChange = (selectedOption: any) => {
    if (selectedOption && selectedOption.onClick) {
      selectedOption.onClick();
    }
  };

  return (
    <div className={`flex items-center gap-2 min-w-0 w-50`}>
      {visibleActions.map((action) => (
        <div
          key={action.id}
          onClick={() => handleActionClick(action)}
          className={`flex items-center gap-1 px-2 py-1 text-sm font-medium text-neutral-dark text-center
             hover:text-primary hover:bg-primary-lightest rounded
            focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-50
            cursor-pointer w-auto min-w-fit max-w-48 flex-shrink-0 ${
              action.disabled
                ? 'opacity-50 cursor-not-allowed hover:text-neutral-dark hover:bg-transparent'
                : ''
            }`}
          aria-label={action.label}
          role='button'
          tabIndex={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleActionClick(action);
            }
          }}
        >
          {action.icon && (
            <img
              src={action.icon}
              alt={action.label}
              className='h-4 w-4 flex-shrink-0'
            />
          )}
          <span className='whitespace-nowrap'>{action.label}</span>
        </div>
      ))}

      {hiddenActions.length > 0 && (
        <Dropdown
          options={dropdownOptions}
          onChange={handleDropdownChange}
          triggerProps={{
            placeholder: 'More Actions',
            className:
              'flex items-center gap-3 px-4 py-1 text-sm font-medium text-neutral-dark hover:text-primary hover:bg-primary-lightest rounded focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-50',
            size: 'sm',
            'data-cy': 'more-actions-dropdown',
          }}
          renderOption={(
            option,
            isSelected,
            selectOption,
            { className, ...otherProps }
          ) => (
            <li
              {...otherProps}
              className={`w-full text-left px-3 py-2 text-sm hover:bg-neutral-lightest flex items-center gap-2 ${
                option.disabled
                  ? 'text-neutral-light cursor-not-allowed'
                  : 'text-neutral-dark'
              } ${className}`}
              onClick={() => {
                if (!option.disabled) {
                  selectOption();
                }
              }}
            >
              {option.icon && (
                <img src={option.icon} alt={option.label} className='h-4 w-4' />
              )}
              {option.label}
            </li>
          )}
        />
      )}
    </div>
  );
};

export default Actions;
